<h2 mat-dialog-title class="dialog-title !text-xl !font-bold !mb-2">Renegociação de Parcelas</h2>

<mat-dialog-content class="dialog-content">
    <div class="mb-3">
        <p class="text-muted mb-1">Valor total do documento: <strong>{{ data.valorTotal | currency:'BRL' }}</strong></p>
        <p class="mb-0">Valor em aberto para renegociação: <strong class="text-primary">{{ data.valorEmAberto |
                currency:'BRL' }}</strong></p>
    </div>

    <div [formGroup]="form">
        <div class="row">
            <div class="col-12 col-md-4">
                @if (data.listaTiposParcelamento.length > 0) {
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Condição / Tipo</mat-label>
                    <mat-select formControlName="idTipoParcelamento">
                        @for (item of data.listaTiposParcelamento; track item.idTipoParcelamento) {
                        <mat-option [value]="item.idTipoParcelamento">{{item.descricao}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                }
            </div>

            <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Vencimento Inicial</mat-label>
                    <input matInput [matDatepicker]="pickerVenc" formControlName="dataVencimento" (input)="onDateInput($event)">
                    <mat-datepicker-toggle matIconSuffix [for]="pickerVenc"></mat-datepicker-toggle>
                    <mat-datepicker #pickerVenc></mat-datepicker>
                </mat-form-field>
            </div>

            <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Intervalo (dias)</mat-label>
                    <input matInput formControlName="intervaloDiasParcelas" [currencyMask]="integerMask" placeholder="Ex: 30">
                </mat-form-field>
            </div>

            <div class="col-12 col-md-6">
                @if (data.listaFormaPagamento.length > 0) {
                <app-select-pesquisavel [control]="idFormaPagamentoControl" [offlineList]="data.listaFormaPagamento"
                    label="Forma de Pagamento" idField="idFormaPagamento" nameField="descricao" [isOptional]="true">
                </app-select-pesquisavel>
                }
            </div>

            <div class="col-12 col-md-6">
                @if (data.listaContaFinanceira.length > 0) {
                <app-select-pesquisavel [control]="idContaFinanceiraControl" [offlineList]="data.listaContaFinanceira"
                    label="Conta Financeira" idField="idContaFinanceira" nameField="descricao" [isOptional]="true">
                </app-select-pesquisavel>
                }
            </div>
        </div>

        <div class="d-flex justify-content-end mb-3 simular-btn-container">
            <button type="button" mat-stroked-button class="btn-secondary" (click)="simular()" [disabled]="isSimulando">
                @if (isSimulando) {
                <mat-spinner diameter="18" class="me-2"></mat-spinner>
                }
                @else {
                <mat-icon>preview</mat-icon> Simular Parcelas
                }
            </button>
        </div>

        <!-- Grid de parcelas simuladas -->
        @if (parcelasArray.length > 0) {
        <div class="simulacao-container">
            <div class="section-subtitle">
                <mat-icon>table_chart</mat-icon>
                <span>Novas Parcelas</span>
            </div>

            <div formArrayName="parcelas">
                @for (ctrl of parcelasArray.controls; track $index; let i = $index) {
                <div class="row g-2 mb-1" [formGroupName]="$index">
                    <div class="col-auto simulacao-index">{{ i + 1 }}</div>
                    <div class="col-12 col-md-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Vencimento</mat-label>
                            <input matInput [matDatepicker]="pickerParcVenc" formControlName="dataVencimento" (input)="onDateInput($event)">
                            <mat-datepicker-toggle matIconSuffix [for]="pickerParcVenc"></mat-datepicker-toggle>
                            <mat-datepicker #pickerParcVenc></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Valor (R$)</mat-label>
                            <input matInput formControlName="valor" [currencyMask]="data.currencyMask"
                                (blur)="onParcelaValorChange(i)">
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Descrição</mat-label>
                            <input matInput formControlName="descricao">
                        </mat-form-field>
                    </div>
                </div>
                }
            </div>
        </div>
        }
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions mt-4">
    <button mat-flat-button class="btn-secondary mr-2" (click)="cancelar()" [disabled]="isSalvando">Cancelar</button>
    <button mat-flat-button class="btn-primary" (click)="confirmar()" [disabled]="!simulado || isSalvando">
        @if (isSalvando) {
        <mat-spinner diameter="18" class="me-2"></mat-spinner>
        }
        @else {
        Confirmar Renegociação
        }
    </button>
</mat-dialog-actions>